module.exports = __webpack_public_path__ + "0e85915ce2ecde4fabfdab9f64c2b069.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/notification/images/reg.png
 ** module id = 1197
 ** module chunks = 0
 **/